import {Map} from 'immutable';

import * as CouponRateActions from 'actions/CouponRate';
import * as MakeBetActions from 'actions/MakeBet';
import * as BettingModeActions from 'actions/BettingMode';
import * as SignoutActions from 'actions/auth/SignoutAction';
import * as StorageActions from 'actions/Storage';

const initialState = new Map();

export default function betSlipAmountsReducer(betSlipAmounts, action) {
    switch (action.type) {
        case StorageActions.LOAD_STORAGE:
            const storedBetSlipAmounts = action.data.betSlipAmounts;
            if (storedBetSlipAmounts !== undefined && storedBetSlipAmounts !== null) {
                for (let rateId in storedBetSlipAmounts) {
                    betSlipAmounts = betSlipAmounts.set(Number(rateId), new Map(storedBetSlipAmounts[rateId]));
                }
            }
            break;

        case SignoutActions.SUCCESS_SIGNOUT:
            return initialState;

        /*case CouponRateActions.SET_COUPON_BET_TYPE:
            const betTypeIndex = action.data;
            return (betTypeIndex !== 0 && betTypeIndex !== -1) ? initialState : betSlipAmounts;*/

        case CouponRateActions.ADD_COUPON_RATE:
            return addCouponBetSlipAmount(betSlipAmounts, action.data);

        case CouponRateActions.REMOVE_COUPON_RATE:
            return removeCouponBetSlipAmount(betSlipAmounts, action.data);

        case CouponRateActions.CHANGE_COUPON_SLIP_AMOUNT:
            return changeCouponBetSlipAmount(betSlipAmounts, action.data);

        case CouponRateActions.REMOVE_COUPON_RATES:
            return initialState;

            //case MakeBetActions.MAKE_BET:
                //return initialState;

        case MakeBetActions.SUCCESS_MAKE_BET:
            const createdBets = action.data;
            let rateBlockNum = 0;

            for (let offset = 0; offset < createdBets.length; offset++) {
                const createdBet = createdBets[offset];

                if (createdBet.error !== undefined && createdBet.error) {
                    if (createdBet.error === -3 && createdBet.factors !== undefined) {
                        rateBlockNum++;
                    }
                    if(createdBet.error === -18){
                        rateBlockNum++;
                        ((createdBet.basketBet || {}).factors || []).map(({factorId}) => {
                            betSlipAmounts = betSlipAmounts.setIn([factorId, 'amount'], 0)
                            betSlipAmounts = betSlipAmounts.setIn([factorId, 'alternativeStake'], createdBet.alternativeStake)
                        })
                    }
                }
            }

            return (rateBlockNum === 0) ? initialState : betSlipAmounts;

        case MakeBetActions.FAILURE_MAKE_BET:
        case BettingModeActions.TOGGLE_ONE_CLICK_MODE:
            return initialState;
    }

    return betSlipAmounts;
}

function addCouponBetSlipAmount(betSlipAmounts, addRate) {
    const rateId = addRate.rate.get('id');

    if (!betSlipAmounts.has(rateId)) {
        betSlipAmounts = betSlipAmounts.set(rateId, new Map({amount: 0, isFreeBet: false}));
    }

    return betSlipAmounts;
}

function removeCouponBetSlipAmount(betSlipAmounts, removeCouponRate) {
    const rateId = removeCouponRate.rateId;

    betSlipAmounts = betSlipAmounts.delete(rateId);

    return betSlipAmounts;
}

function changeCouponBetSlipAmount(betSlipAmounts, couponRates) {
    for (let offset = 0; offset < couponRates.length; offset++) {
        const rateId = couponRates[offset].rateId;
        const amount = couponRates[offset].amount;

        betSlipAmounts = betSlipAmounts.setIn([rateId, 'amount'], amount);

        if (couponRates[offset].isFreeBet !== undefined) {
            betSlipAmounts = betSlipAmounts.map(slipAmount => slipAmount.set('isFreeBet', false));
            betSlipAmounts = betSlipAmounts.setIn([rateId, 'isFreeBet'], couponRates[offset].isFreeBet);
        }
    }

    return betSlipAmounts;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/betSlipAmountsReducer.js